import { render } from "./AddParticipants.vue?vue&type=template&id=5d31cc04&scoped=true"
import script from "./AddParticipants.vue?vue&type=script&lang=js"
export * from "./AddParticipants.vue?vue&type=script&lang=js"

import "./AddParticipants.vue?vue&type=style&index=0&id=5d31cc04&scoped=true&lang=css"

import exportComponent from "/home/walnit/Documents/AppVenture/nush-bookings-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d31cc04"]])

export default __exports__